<template>
    <div class="map-legend">
        <p class="title">
            File Classification
        </p>
        <ul class="legend">
            <li
                v-for="item in classifications"
                :key="item.code"
                class="item"
                :class="{ 'not-selected': (selectedClassification!= '' && selectedClassification!= item.code)}"
                @click="toggleFilterStatus(item.code, item.title)"
            >
                <div
                    class="color"
                    :class="item.color"
                />
                <span class="item-label">
                    {{ item.title }}
                </span>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import useApp from '@/composables';

export default defineComponent({
    name: 'Header',
    components: {},
    setup() {
        const { state, toggleFilterStatus } = useApp();

        const classifications = [
            {
                color: 'red',
                title: 'Contaminated Sites, Upstream',
                code: 'CSU'
            },
            {
                color: 'green',
                title: 'Reclamation Certificates',
                code: 'REC'
            },
            {
                color: 'orange',
                title: 'Petroleum Storage Tank',
                code: 'PST'
            },
            {
                color: 'blue',
                title: 'Site Assessments, Contaminated Sites, Cleanup, Decommissioning Facilities',
                code: 'SCD'
            }
        ];

        const selectedClassification = computed(() => state.filteredStatusCode);

        return {
            selectedClassification,
            toggleFilterStatus,
            classifications
        };
    }
});
</script>

<style lang="postcss" scoped>
.map-legend {
    @apply w-full bg-map-legend-background p-4 shadow;

    .title {
        @apply text-sm mb-2;
    }

    .legend {
        @apply flex flex-wrap;

        .item {
            @apply flex mb-2 text-xs cursor-pointer;
            min-width: 45%;
            max-width: 50%;

            &.not-selected {
                @apply opacity-25;
            }

            .item-label {
                max-width: 90%;
                transform: translate(0, -2px);
            }
        }
    }

    .color {
        @apply mr-2 rounded-full w-4 h-4 inline-block;

        &.red {
            @apply bg-map-contaminated-site-upstream;
        }

        &.green {
            @apply bg-map-reclamation;
        }

        &.orange {
            @apply bg-map-petroleum-storage-tank;
        }

        &.blue {
            @apply bg-map-site-contamination-and-decomissioning;
        }
    }
}
</style>
